module.exports = __webpack_public_path__ + "static/media/preview.747714a1.webp";